// Mock data for the application
// This file contains placeholder data for development

export const destinations = [
  {
    id: 1,
    name: 'French Riviera',
    country: 'France',
    description: 'The glamorous French Riviera offers stunning coastlines, luxury villas, and world-class dining.',
    image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=800',
    villaCount: 45
  },
  {
    id: 2,
    name: 'Tuscany',
    country: 'Italy',
    description: 'Experience the rolling hills, vineyards, and Renaissance art of beautiful Tuscany.',
    image: 'https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=800',
    villaCount: 32
  },
  {
    id: 3,
    name: 'Santorini',
    country: 'Greece',
    description: 'White-washed buildings, blue domes, and breathtaking sunsets over the Aegean Sea.',
    image: 'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?w=800',
    villaCount: 28
  }
];

export const emotionalCategories = [
  {
    id: 'romance',
    name: 'Romance',
    icon: '💕',
    description: 'Villas parfaites pour les moments intimes',
    color: 'rose'
  },
  {
    id: 'family',
    name: 'Famille',
    icon: '👨‍👩‍👧‍👦',
    description: 'Espaces adaptés aux familles',
    color: 'blue'
  },
  {
    id: 'wellness',
    name: 'Bien-être',
    icon: '🧘',
    description: 'Sérénité et détente absolue',
    color: 'green'
  },
  {
    id: 'adventure',
    name: 'Aventure',
    icon: '🏔️',
    description: 'Pour les amateurs de sensations',
    color: 'orange'
  },
  {
    id: 'luxury',
    name: 'Luxe',
    icon: '✨',
    description: 'Le summum du raffinement',
    color: 'amber'
  }
];

// Emotions object for EmotionalFilters component
export const emotions = {
  serenite: {
    label: 'Sérénité Pure',
    colors: ['#E8F4F8', '#B8DCE8'],
    description: 'Des villas qui incarnent la paix et la tranquillité absolue'
  },
  privilege: {
    label: 'Privilège Absolu',
    colors: ['#2C1810', '#5A3825'],
    description: 'Le summum du luxe et de l\'exclusivité'
  },
  anticipation: {
    label: 'Anticipation Magique',
    colors: ['#FFF5E1', '#FFE4B5'],
    description: 'L\'excitation d\'une expérience unique qui vous attend'
  },
  intimite: {
    label: 'Intimité Romantique',
    colors: ['#FFF0F5', '#FFE4E1'],
    description: 'Des moments précieux à deux dans un cadre enchanteur'
  },
  liberte: {
    label: 'Liberté Infinie',
    colors: ['#F0FFF0', '#E0FFE0'],
    description: 'L\'espace et la liberté de vivre à votre rythme'
  }
};

export const conciergeMessages = [
  {
    trigger: 'general_welcome',
    message: "Bonjour ! Je suis Marie, votre concierge personnel. Comment puis-je vous aider à trouver la villa parfaite pour votre séjour ?",
    quickReplies: [
      "Rechercher une villa",
      "Mes favoris",
      "Parler à un conseiller"
    ]
  },
  {
    trigger: 'villa_details',
    message: "Cette villa vous intéresse ? Je peux vous donner plus d'informations ou organiser une visite virtuelle.",
    quickReplies: [
      "Plus d'infos",
      "Visite virtuelle",
      "Voir les disponibilités"
    ]
  }
];

export const mockVillas = [
  {
    id: 1,
    name: 'Villa Serenity',
    location: 'Saint-Tropez, France',
    price: 2500,
    bedrooms: 5,
    bathrooms: 4,
    capacity: 10,
    image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800',
    emotionalTags: ['romance', 'luxury']
  },
  {
    id: 2,
    name: 'Casa Bella Vista',
    location: 'Tuscany, Italy',
    price: 1800,
    bedrooms: 4,
    bathrooms: 3,
    capacity: 8,
    image: 'https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?w=800',
    emotionalTags: ['family', 'wellness']
  },
  {
    id: 3,
    name: 'Villa Paradise',
    location: 'Santorini, Greece',
    price: 3200,
    bedrooms: 6,
    bathrooms: 5,
    capacity: 12,
    image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800',
    emotionalTags: ['luxury', 'romance']
  }
];

// Alias for mockVillas
export const sampleVillas = mockVillas;

export const testimonials = [
  {
    id: 1,
    name: 'Sophie & Marc L.',
    location: 'Paris, France',
    rating: 5,
    text: 'Une expérience exceptionnelle ! La villa était encore plus belle que sur les photos. Le service était impeccable.',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200',
    date: '2024-03'
  },
  {
    id: 2,
    name: 'James Wilson',
    location: 'London, UK',
    rating: 5,
    text: 'Absolutely stunning property with breathtaking views. The concierge service made our stay unforgettable.',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200',
    date: '2024-02'
  },
  {
    id: 3,
    name: 'Isabella Romano',
    location: 'Milan, Italy',
    rating: 5,
    text: 'La villa perfetta per le nostre vacanze in famiglia. Servizio eccellente e attenzione ai dettagli.',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200',
    date: '2024-01'
  }
];

export const partners = [
  {
    id: 1,
    name: 'Michelin Guide',
    icon: 'MichelinIcon',
    logo: 'https://via.placeholder.com/200x80?text=Michelin',
    url: '#'
  },
  {
    id: 2,
    name: 'Relais & Châteaux',
    icon: 'RelaisIcon',
    logo: 'https://via.placeholder.com/200x80?text=Relais',
    url: '#'
  },
  {
    id: 3,
    name: 'Leading Hotels',
    icon: 'LeadingIcon',
    logo: 'https://via.placeholder.com/200x80?text=Leading+Hotels',
    url: '#'
  },
  {
    id: 4,
    name: 'Virtuoso',
    icon: 'VirtuosoIcon',
    logo: 'https://via.placeholder.com/200x80?text=Virtuoso',
    url: '#'
  }
];

